var resetUI = function() {
  document.dispatchEvent(new CustomEvent('behavior:close')); // Dispatch custom event here to close all behaviors
};

export default resetUI;
